import CategoricalSchemeWrapper from './CategoricalSchemeWrapper';
import SequentialSchemeWrapper from './SequentialSchemeWrapper';
import DivergingSchemeWrapper from './DivergingSchemeWrapper';

function wrapColorScheme(scheme) {
  switch (scheme.type) {
    case 'categorical':
      return scheme instanceof CategoricalSchemeWrapper ? scheme : new CategoricalSchemeWrapper(scheme);

    case 'sequential':
      return scheme instanceof SequentialSchemeWrapper ? scheme : new SequentialSchemeWrapper(scheme);

    case 'diverging':
      return scheme instanceof DivergingSchemeWrapper ? scheme : new DivergingSchemeWrapper(scheme);

    default:
      throw new Error(`Unknown scheme type: ${scheme.type}`);
  }
}

export default wrapColorScheme;